'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var fadeInRight = {
  from: {
    opacity: 0,
    transform: (0, _utils.translate3d)('100%', 0, 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInRight;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-animations/lib/fade-in-right.js
// module id = 916
// module chunks = 0